module.exports = __webpack_public_path__ + "assets/img/btn-view-9c9b537b.png";